import { useRef } from 'react'
import Footer from './components/Footer'
import Header from './components/Header'
import Menu from './components/Menu'
import useClickOutside from '../../hooks/useClickOutside'


const Sidebar = ({
  isAnimation = false,
  userData,
  setOpenDrawer,
  handleOutside = () => {},
}) => {
  const clickRef = useRef()
  useClickOutside(clickRef, handleOutside, true)

  return (
    <section
      ref={clickRef}
      id="sidebar"
      style={{
        top: 0,
        position: 'sticky'
      }}
      className={`${
        isAnimation && 'sidebar-animation'
      } bg-bg-brand new-sidebar d-flex flex-column justify-content-between overflow-auto`}
    >
      <div className="p-3">
        {' '}
        <div className="mb-5">
          <Header />
        </div>
        <Menu userData={userData} setOpenDrawer={setOpenDrawer} />
      </div>
      <Footer setOpenDrawer={setOpenDrawer} />
    </section>
  )
}

export default Sidebar
